'use client'

import React from 'react'
import AnimatedSection from '@/components/AnimatedSection'
import styles from './styles.module.css'

interface ApproachItem {
  svg: React.ReactNode
  title: string
  description: string
}

const OurApproach: React.FC = () => {
  const approaches: ApproachItem[] = [
    {
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="18" viewBox="0 0 27 18" fill="none">
          <path d="M6.66667 4H0V1.33333H6.66667V4ZM6.66667 8H0V10.6667H6.66667V8ZM24.7867 17.3333L19.68 12.2267C18.6133 12.92 17.36 13.3333 16 13.3333C12.32 13.3333 9.33333 10.3467 9.33333 6.66667C9.33333 2.98667 12.32 0 16 0C19.68 0 22.6667 2.98667 22.6667 6.66667C22.6667 8.02667 22.2533 9.28 21.56 10.3333L26.6667 15.4533L24.7867 17.3333ZM20 6.66667C20 4.46667 18.2 2.66667 16 2.66667C13.8 2.66667 12 4.46667 12 6.66667C12 8.86667 13.8 10.6667 16 10.6667C18.2 10.6667 20 8.86667 20 6.66667ZM0 17.3333H13.3333V14.6667H0V17.3333Z" fill="#F23B67"/>
        </svg>
      ),
      title: 'Глубокое погружение',
      description: 'Тщательно изучаем ваши бизнес-процессы, чтобы создать стратегию, которая учитывает цели на 3–5 лет вперёд.'
    },
    {
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26" viewBox="0 0 27 26" fill="none">
          <path d="M0 23.3067L10 13.2933L15.3333 18.6267L24.7867 8L26.6667 9.88L15.3333 22.6267L10 17.2933L2 25.3067L0 23.3067ZM2 17.3067L10 9.29333L15.3333 14.6267L26.6667 1.88L24.7867 0L15.3333 10.6267L10 5.29333L0 15.3067L2 17.3067Z" fill="#F23B67"/>
        </svg>
      ),
      title: 'Долгосрочное планирование',
      description: 'Мы проектируем систему с учётом будущего масштабирования, чтобы архитектура оставалась гибкой и надёжной при любом росте нагрузки.'
    },
    {
      svg: (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="16" viewBox="0 0 32 16" fill="none">
          <path d="M16 9C18.1733 9 20.0933 9.52 21.6533 10.2C23.0933 10.84 24 12.28 24 13.84V16H8V13.8533C8 12.28 8.90667 10.84 10.3467 10.2133C11.9067 9.52 13.8267 9 16 9ZM5.33333 9.33333C6.8 9.33333 8 8.13333 8 6.66667C8 5.2 6.8 4 5.33333 4C3.86667 4 2.66667 5.2 2.66667 6.66667C2.66667 8.13333 3.86667 9.33333 5.33333 9.33333ZM6.84 10.8C6.34667 10.72 5.85333 10.6667 5.33333 10.6667C4.01333 10.6667 2.76 10.9467 1.62667 11.44C0.64 11.8667 0 12.8267 0 13.9067V16H6V13.8533C6 12.7467 6.30667 11.7067 6.84 10.8ZM26.6667 9.33333C28.1333 9.33333 29.3333 8.13333 29.3333 6.66667C29.3333 5.2 28.1333 4 26.6667 4C25.2 4 24 5.2 24 6.66667C24 8.13333 25.2 9.33333 26.6667 9.33333ZM32 13.9067C32 12.8267 31.36 11.8667 30.3733 11.44C29.24 10.9467 27.9867 10.6667 26.6667 10.6667C26.1467 10.6667 25.6533 10.72 25.16 10.8C25.6933 11.7067 26 12.7467 26 13.8533V16H32V13.9067ZM16 0C18.2133 0 20 1.78667 20 4C20 6.21333 18.2133 8 16 8C13.7867 8 12 6.21333 12 4C12 1.78667 13.7867 0 16 0Z" fill="#F23B67"/>
        </svg>
      ),
      title: 'Командная работа',
      description: 'Весь цикл разработки над вашим проектом работает выделенная группа экспертов, которая полностью сфокусирована на результате.'
    }
  ]

  return (
    <section className={styles.ourApproach}>
      <div className={styles.container}>
        <div className={styles.content}>
          <AnimatedSection animation="slideUp">
            <div className={styles.subtitle}>Наш подход</div>
            <h2 
              className={styles.title}
              dangerouslySetInnerHTML={{ __html: '<span>ИТ-партнёрство на годы:</span> создаём экосистемы, которые работают<br> на ваш бизнес не один год' }}
            />
          </AnimatedSection>
          
          <div className={styles.items}>
            {approaches.map((item, index) => (
              <AnimatedSection key={index} animation="slideUp">
                <div className={styles.item}>
                  <div className={styles.itemHeader}>
                    <div className={styles.itemSvg}>
                      {item.svg}
                    </div>
                    <h3 className={styles.itemTitle}>{item.title}</h3>
                  </div>
                  <p className={styles.itemDescription}>{item.description}</p>
                </div>
              </AnimatedSection>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

OurApproach.displayName = 'OurApproach'

export default OurApproach